export * from './audio-detect'
export * from './load-script'
export * from './request'



/** WEBPACK FOOTER **
 ** ./~/.5.0.0@standard-loader!./src/utils/index.js
 **/